<div class="whp" [dir]="isRTL ? 'rtl' : 'ltr'">
  <!-- Header -->
  <header class="whp__header">
    <div class="whp__header-main">
      <span class="whp__icon" aria-hidden="true">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      </span>
      <div class="whp__header-text">
        <h2 class="whp__title">
          {{ "AUTOMATION.FORM.WORK_HOUR" | translate }}
        </h2>
        <p class="whp__subtitle">
          {{ "AUTOMATION.FORM.WORK_HOUR_HINT" | translate }}
        </p>
      </div>
    </div>
    <button
      type="button"
      class="whp__close"
      (click)="close()"
      [attr.aria-label]="'APP_BUTTONS.CANCEL' | translate"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M18 6 6 18M6 6l12 12" />
      </svg>
    </button>
  </header>

  <!-- Body -->
  <div class="whp__body">
    <form [formGroup]="workHourForm">
      <div formArrayName="timeBlocks" class="whp__slots">
        <div
          *ngFor="let block of timeBlocks.controls; let i = index"
          [formGroupName]="i"
          class="whp__slot"
          [class.whp__slot--invalid]="block.errors?.['invalidTimeRange']"
        >
          <div class="whp__slot-head">
            <span class="whp__slot-icon" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
              </svg>
            </span>
            <div class="whp__slot-id">
              <span class="whp__slot-title">
                {{ "AUTOMATION.FORM.WORK_HOUR" | translate }}
              </span>
              <span class="whp__slot-index">#{{ i + 1 }}</span>
            </div>
            <button
              type="button"
              class="whp__slot-remove"
              (click)="removeTimeBlock(i)"
              *ngIf="timeBlocks.length > 1"
              [attr.aria-label]="'MODULE.BUTTON.DELETE' | translate"
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M3 6h18" />
                <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
              </svg>
            </button>
          </div>

          <div class="whp__slot-body">
            <div class="whp__slot-fields">
              <div class="whp__field">
                <label [for]="'from-' + i" class="whp__label">
                  {{ "AUTOMATION.FORM.START_WORK_HOUR" | translate }}
                </label>
                <input
                  type="time"
                  [id]="'from-' + i"
                  formControlName="from"
                  class="whp__input"
                />
              </div>

              <span class="whp__arrow" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                </svg>
              </span>

              <div class="whp__field">
                <label [for]="'to-' + i" class="whp__label">
                  {{ "AUTOMATION.FORM.END_WORK_HOUR" | translate }}
                </label>
                <input
                  type="time"
                  [id]="'to-' + i"
                  formControlName="to"
                  class="whp__input"
                />
              </div>
            </div>

            <div class="whp__days">
              <span class="whp__label">{{ "STORE_STATUS.DAYS" | translate }}</span>
              <div class="whp__day-list">
                <button
                  *ngFor="let day of weekDays"
                  type="button"
                  class="whp__day"
                  [class.whp__day--on]="hasDay(block, day)"
                  [attr.aria-pressed]="hasDay(block, day)"
                  (click)="toggleDay(block, day)"
                >
                  {{ "STORE_STATUS.DAY." + day | translate }}
                </button>
              </div>
            </div>

            <p *ngIf="block.errors?.['invalidTimeRange']" class="whp__error">
              {{ "AUTOMATION.FORM.TIME_RANGE_INVALID" | translate }}
            </p>
          </div>
        </div>
      </div>

      <button type="button" class="whp__add" (click)="addTimeBlock()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 5v14M5 12h14" />
        </svg>
        {{ "APP_BUTTONS.ADD" | translate }}
      </button>
    </form>
  </div>

  <!-- Footer -->
  <footer class="whp__footer">
    <button type="button" class="whp__btn whp__btn--ghost" (click)="close()">
      {{ "APP_BUTTONS.CANCEL" | translate }}
    </button>
    <button type="button" class="btn-pill btn-pill--primary" (click)="onSubmit()">
      {{ "APP_BUTTONS.SAVE" | translate }}
    </button>
  </footer>
</div>
